import React from 'react';
import PropTypes from 'prop-types';
import { shortDateRangeFormat } from '~/modules/common/dates/format';
import { Date } from '~/modules/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline/periodScale';

export const formats = {
  days: 'MMM d yyyy',
  years: 'yyyy',
  quarters: "'Q'q yyyy",
  months: 'LLLL yyyy'
};

export const PeriodStartDateLabel = ({
  scale,
  dateRange,
  dateRangeClasses
}) => {
  if (scale === PERIOD_SCALE_ENUM.WEEKS) {
    return (
      <span data-qe-id="DateField" className={dateRangeClasses.date}>
        {shortDateRangeFormat({
          start: dateRange.startDate,
          end: dateRange.endDate
        })}
      </span>
    );
  }

  return (
    <Date
      data-qe-id="DateField"
      value={dateRange.startDate}
      format={formats[scale]}
      className={dateRangeClasses.date}
    />
  );
};

PeriodStartDateLabel.propTypes = {
  scale: PropTypes.string.isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.object.isRequired,
    endDate: PropTypes.object.isRequired
  }).isRequired,
  dateRangeClasses: PropTypes.object.isRequired
};

export default PeriodStartDateLabel;
